import { jsx as _jsx } from "react/jsx-runtime";
import { H2 } from "../../text";
import { styled } from "../../theme";
import { useBlockComponentContext } from "../BlockComponentContext";
import { ADAPTABLE_TEXT_CLASSNAME } from "../block-slide";
export const BlockSubtitle = ({ id, translationKey }) => {
    const { Markdown, Translated } = useBlockComponentContext();
    return (_jsx(Subtitle, { className: ADAPTABLE_TEXT_CLASSNAME, id: id, children: _jsx(Translated, { translationKey: translationKey, render: ({ translation }) => _jsx(Markdown, { source: translation }) }) }));
};
export const Subtitle = styled(H2) `
  margin-top: 0.625em;
  margin-bottom: 0.625em;
  font-size: 2em;
  line-height: 1.5em;
`;
